// @ts-ignore
import env from 'libs/env';

const ttCdnList = [
    'sf1-ttcdn-tos.pstatp.com',
    'sf3-ttcdn-tos.pstatp.com',
    'sf6-ttcdn-tos.pstatp.com'
];

const hsCdnList = ['lf1-hscdn-tos.pstatp.com'];

const dyCdnList = ['p1-dy.byteimg.com', 'p3-dy.byteimg.com', 'p9-dy.byteimg.com'];

function hash(text) {
    let seed = 5381;
    let index = text.length;

    while (index) {
        // eslint-disable-next-line no-bitwise
        seed = (seed * 33) ^ text.charCodeAt(--index);
    }

    // eslint-disable-next-line no-bitwise
    return seed >>> 0;
}

/**
 * @description 判断是否支持webp
 * @returns {void}
 */
function _testWebp() {
    // ios目前还不支持webp
    if (env.isIOS) {
        return false;
    }
    const webP = new Image();
    webP.src =
        'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wA' +
        'iMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
    // eslint-disable-next-line func-name-matching
    webP.onload = webP.onerror = function onload() {
        env.webpSupport = webP.height === 2;
    };
}

_testWebp();

function getCDNDomain(url, biz) {
    let cdnList = ttCdnList;
    switch (biz) {
        case 'hs':
            cdnList = hsCdnList;
            break;
        case 'dy':
            cdnList = dyCdnList;
            break;
        default:
            break;
    }
    return cdnList[hash(url) % cdnList.length];
}

// interface IImgUrlOption {
//     type?: 'jpg' | 'png' | 'webp' | 'gif';
//     height?: number;
//     width?: number;
//     quality?: number;
// }

/**
 * 修改图片 url，转换成 options 中的配置的图片
 * @param url
 * @param option {
 *     type?: "jpg"|"png"|"webp"|"gif"
 *     width?: number
 *     height?: number
 *     quality?: number
 * }
 */
// eslint-disable-next-line complexity
export const compressImg = (url, { type = 'jpg', height = 0, width = 0, quality = 50 } = {}) => {
    const suffix = `~${width}x${height}_q${quality}.${type}`;

    let mat = url.match(/p3a.pstatp.com\/(large|origin)\/(.*)/);
    if (mat && mat[1] && mat[2]) {
        if (mat[2].indexOf('temai') === 0) {
            return `https://${getCDNDomain(mat[2], 'tt')}/img/${mat[2]}${suffix}`;
        }
        return `https://${getCDNDomain(mat[2], 'tt')}/img/mosaic-legacy/${mat[2]}${suffix}`;
    }

    if (url.indexOf('hscdn-tos.pstatp.com/obj/temai/') > 0) {
        return (
            url.replace('hscdn-tos.pstatp.com/obj/temai/', 'hscdn-tos.pstatp.com/img/temai/') +
            suffix
        );
    }

    if (url.indexOf('ttcdn-tos.pstatp.com/obj/temai/') > 0) {
        return (
            url.replace('ttcdn-tos.pstatp.com/obj/temai/', 'ttcdn-tos.pstatp.com/img/temai/') +
            suffix
        );
    }

    if (url.indexOf('ttcdn-tos.pstatp.com/obj/web.business.image/') > 0) {
        return (
            url.replace(
                'ttcdn-tos.pstatp.com/obj/web.business.image/',
                'ttcdn-tos.pstatp.com/img/web.business.image/'
            ) + suffix
        );
    }

    if (url.indexOf('dy.byteimg.com/obj/mosaic-legacy/') > 0) {
        return (
            url.replace('dy.byteimg.com/obj/mosaic-legacy/', 'dy.byteimg.com/img/mosaic-legacy/') +
            suffix
        );
    }

    if (url.indexOf('dy.byteimg.com/obj/') > 0) {
        return url.replace('dy.byteimg.com/obj/', 'dy.byteimg.com/img/') + suffix;
    }

    mat = url.match(/hscdn-tos\.pstatp\.com\/img\/temai\/(.*)~/);
    if (mat && mat[1]) {
        return `https://${getCDNDomain(mat[1], 'hs')}/img/temai/${mat[1]}${suffix}`;
    }

    mat = url.match(/ttcdn-tos\.pstatp\.com\/img\/temai\/(.*)~/);
    if (mat && mat[1]) {
        return `https://${getCDNDomain(mat[1], 'tt')}/img/temai/${mat[1]}${suffix}`;
    }

    mat = url.match(/ttcdn-tos\.pstatp\.com\/img\/web\.business\.image\/(.*)~/);
    if (mat && mat[1]) {
        return `https://${getCDNDomain(mat[1], 'tt')}/img/web.business.image/${mat[1]}${suffix}`;
    }

    mat = url.match(/dy\.byteimg\.com\/img\/mosaic-legacy\/(.*)~/);
    if (mat && mat[1]) {
        return `https://${getCDNDomain(mat[1], 'dy')}/img/mosaic-legacy/${mat[1]}${suffix}`;
    }

    mat = url.match(/ttcdn-tos\.pstatp\.com\/img\/mosaic-legacy\/(.*)~/);
    if (mat && mat[1]) {
        return `https://${getCDNDomain(mat[1], 'tt')}/img/mosaic-legacy/${mat[1]}${suffix}`;
    }

    mat = url.match(/dy\.byteimg\.com\/img\/(.*)~/);
    if (mat && mat[1]) {
        return `https://${getCDNDomain(mat[1], 'dy')}/img/${mat[1]}${suffix}`;
    }

    if (
        type === 'webp' &&
        env.webpSupport &&
        /ttcdn-tos\.pstatp\.com\/img\/mosaic-legacy\/.+\.image$/.test(url)
    ) {
        return `${url.slice(0, -5)}webp`;
    }

    if (
        type === 'webp' &&
        env.webpSupport &&
        /hscdn-tos\.pstatp\.com\/img\/mosaic-legacy\/.+\.image$/.test(url)
    ) {
        return `${url.slice(0, -5)}webp`;
    }

    if (
        type === 'webp' &&
        env.webpSupport &&
        /dy\.byteimg\.com\/img\/mosaic-legacy\/.+\.image$/.test(url)
    ) {
        return `${url.slice(0, -5)}webp`;
    }

    return url;
};

/**
 * 图片使用 rem
 * @param url {string} tos key 或者 tos url
 * @param width {number} 宽度 rem
 * @param height {number} 高度 rem
 * @param [quality] {number} 质量
 * @return {string} url
 */
// export const resizeImgByRem = (url, width, height, quality = 50) => {
//     let urlStr = typeof url === 'object' ? url.url : url;
//
//     if (!urlStr || typeof urlStr !== 'string') {
//         return '';
//     }
//
//     if (urlStr.startsWith('http') && urlStr.includes('cdn-tos.pstatp.com/')) {
//         urlStr = urlStr.replace(/^http:/, 'https:');
//     }
//
//     if (urlStr.startsWith('http') && urlStr.includes('dy.byteimg.com/')) {
//         urlStr = urlStr.replace(/^http:/, 'https:');
//     }
//
//     return compressImg(urlStr, {
//         type: env.webpSupport ? 'webp' : 'png',
//         quality,
//         width: parseInt(window.remToPx(width), 10),
//         height: parseInt(window.remToPx(height), 10)
//     });
// };

// export const fixImgHeight = (height: number) => {
//   return Math.ceil(height / window.devicePixelRatio) * window.devicePixelRatio;
// };
